<template>
  <div class="feds-con">
    <div class="feds-input">
      <el-input v-model="input" placeholder="请输入内容"></el-input>
      <el-button @click="search">搜索</el-button>
    </div>
    <div class="feds-wrapper"></div>
  </div>
</template>
<script>
import axios from "axios";
import G6 from "@antv/g6";
export default {
  components: {},
  data() {
    return {
      keywordlist: [],
      input: "",
      graph:null
    };
  },
  mounted() {
    // this.getdata();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      // if(!localStorage.getItem("token")){
      //   localStorage.setItem('routefrom','verb')
      //   vm.$router.push('/login')
      // }
    });
  },
  methods: {
    getdata() {
      axios
        .get("http://10.10.10.221:8008/info/find_path?items=" + this.input)
        .then((response) => {
          this.keywordlist = response.data.data;
          console.log(this.keywordlist, "---39");
          let parentdiv = document.getElementsByClassName("feds-wrapper")[0];
          for (let i = 0; i < this.keywordlist.length; i++) {
            var div = document.createElement("div");
            div.id = "container" + i;
            div.className = "feds-item";
            parentdiv.appendChild(div);
            let data = {
              nodes: [],
              edges: [],
            };
            for (let j in this.keywordlist[i].entity) {
              data.nodes.push({
                label: this.keywordlist[i].entity[j].label,
                type: this.keywordlist[i].entity[j].type,
                id: this.keywordlist[i].entity[j].label,
                is_center: this.keywordlist[i].entity[j].is_center,
                size:this.keywordlist[i].entity[j].is_center?50:20,
                style:{
                  fill:this.keywordlist[i].entity[j].is_center||this.keywordlist[i].entity[j].is_match?'rgb(255, 168, 68)':''
                }
              });
            }
            data.edges = this.keywordlist[i].relation;
            console.log(data, "---92");
            this.drawimg(div, data);
          }
        })
        
    },
    regnodes(){
      G6.registerNode(
        "bubble",
        {
          draw(cfg, group) {
            const { id, label, is_center, is_match,  } = cfg;
            console.log(cfg,'---78')
            // 名称文本
            // 文本大小
            const text = group.addShape("text", {
              zIndex: 1,
              attrs: {
                text: label,
                textAlign: "center",
                textBaseline: "center",
                y: 4,
                fontFamily: "PingFangSC-Regular",
                // fontSize: id === "paper" ? 16 : 10,
                // fontWeight: id === "paper" ? 600 : 400,
                fill: "#000",
              },
              cursor: "pointer",
              name: "name-text-shape",
            });
            const textWidth = text.getBBox().width;
            const r = parseInt(textWidth) > 30 ? 30 : parseInt(textWidth);
            let attrs = {
              x: 0,
              y: 0,
              r: is_center ? "100" : r,
              // fill: cfg.color || "#666",
              cursor: "pointer",
              // stroke: cfg.stroke || '#666'
            };
            const keyShape = group.addShape("circle", {
              zIndex: 0,
              attrs,
              name: "circle-text-shape",
            });
            group.sort();
            return keyShape;
          },
        },
        "single-node"
      );
    },
    drawimg(con, val) {
      
      const container = con;
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;
      const graph = new G6.Graph({
        container: container,
        width,
        height,
        modes: {
          default: ["zoom-canvas", "drag-canvas", "drag-node"],
        },
        layout: {
          type: "radial",
          unitRadius: 150,
          linkDistance: 150,
          // nodeSize: 50,
        },
        animate: true,
        defaultNode: {
          type: "bubble",
          unitRadius: 150,
          linkDistance: 150,
          nodeSize: 150,
        },
      });

      const data = val;
      //   const nodes = data.nodes;
      graph.data(data);
      graph.render();

      //   graph.on("node:dragstart", function (e) {
      //     graph.layout();
      //     refreshDragedNodePosition(e);
      //   });
      //   graph.on("node:drag", function (e) {
      //     refreshDragedNodePosition(e);
      //   });
      //   graph.on("node:dragend", function (e) {
      //     e.item.get("model").fx = null;
      //     e.item.get("model").fy = null;
      //   });

      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!graph || graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          graph.changeSize(container.scrollWidth, container.scrollHeight);
        };

      //   function refreshDragedNodePosition(e) {
      //     const model = e.item.get("model");
      //     model.fx = e.x;
      //     model.fy = e.y;
      //   }
    },
    
    search() {
      let con = document.getElementsByClassName("feds-wrapper")[0];
      con.innerHTML = "";
      this.regnodes()
      this.getdata();
    },
  },
};
</script>
<style>
/* body {
  background-color: #e1e1e1;
} */
* {
  box-sizing: border-box;
}
.feds-con {
  padding: 20px;
  width: 100%;
}
.feds-input {
  width: 200px;
}
.feds-item {
  width: 100%;
  height: 400px;
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// src/pages/feds/index.vue